import React from 'react';

/**
 * Renders the customSubmissionBoundary survey section.
 *
 * Always shows the divider using the section's name (primary) and description
 * (secondary, below the line). Both are optional — nothing renders if unset.
 *
 * Edit mode: a "Save and Finish" button is shown above the divider so suppliers
 *            can save without scrolling back to the header.
 *
 * Sections below this boundary are always rendered read-only for users
 * without the review_survey_submissions permission (enforced in SurveyForm).
 */
export const CustomSubmissionBoundary = ({EditMode, OnFinish, IsValid, Section}) => {

    return (
        <div className="sb-submission-boundary">
            <div className="sb-submission-boundary-divider">
                <hr />
                {Section?.name && (
                    <span className="sb-submission-boundary-label text-muted">
                        {Section.name}
                    </span>
                )}
            </div>
            {Section?.description && (
                <p className="sb-submission-boundary-description text-muted">
                    {Section.description}
                </p>
            )}
        </div>
    );
};
